var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtualBetaWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 928.8 257.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#666;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 129.99,
    y1: 180.79,
    x2: 254.68,
    y2: 59.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0121cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf00f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 31.17,
    y1: 189.2,
    x2: 188.75,
    y2: 10.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 222.76,
    y1: 257.05,
    x2: 343.68,
    y2: 139.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 73.05,
    y1: 2479.44,
    x2: 97.39,
    y2: 2454.8,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2631.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0121cd",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 57.05,
    y1: 2496.8,
    x2: 37.2,
    y2: 2514.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 266.71,
    y1: 152.92,
    x2: 285.08,
    y2: 174.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59006b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#850be8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 253.89,
    y1: 137.21,
    x2: 235.77,
    y2: 115.8,
    xlinkHref: "#linear-gradient-6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Logo VDEX Beta_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M791.5,238.7a11.2,11.2,0,0,1,2.6,7.2,11.4,11.4,0,0,1-1.7,6.1,12,12,0,0,1-4.9,4.2,17.9,17.9,0,0,1-7.7,1.5H765a.5.5,0,0,1-.4-.5V214.1a.5.5,0,0,1,.4-.5h14.4c4.5,0,7.9,1.1,10.2,3.1a10.5,10.5,0,0,1,3.5,8,10.2,10.2,0,0,1-2.2,6.7,11.9,11.9,0,0,1-4.3,3,.5.5,0,0,0,.1.9A12.1,12.1,0,0,1,791.5,238.7ZM769,232.6a.5.5,0,0,0,.5.5h9.8q4.5,0,6.9-2.1a8.2,8.2,0,0,0,0-11.6c-1.6-1.4-4-2-7.1-2h-9.6a.5.5,0,0,0-.5.4Zm18,19.1a7.7,7.7,0,0,0,2.7-6.2,8.2,8.2,0,0,0-2.8-6.4,11.9,11.9,0,0,0-7.6-2.3h-9.8a.5.5,0,0,0-.5.5v16.2a.5.5,0,0,0,.5.5h10A11.4,11.4,0,0,0,787,251.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M818.5,217.7v15.5a.5.5,0,0,0,.5.5h15.8a.5.5,0,0,1,.4.5v2.7a.4.4,0,0,1-.4.4H819a.5.5,0,0,0-.5.5v15.8a.5.5,0,0,0,.5.5h17.6a.5.5,0,0,1,.5.4v2.7a.5.5,0,0,1-.5.5h-22a.5.5,0,0,1-.5-.5V214a.5.5,0,0,1,.5-.4h22a.5.5,0,0,1,.5.4v2.8a.5.5,0,0,1-.5.4H819A.5.5,0,0,0,818.5,217.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.1,214.1v2.7a.5.5,0,0,1-.5.5H870.3a.5.5,0,0,0-.5.5v39.4a.5.5,0,0,1-.4.5h-3.5a.5.5,0,0,1-.5-.5V217.8a.5.5,0,0,0-.5-.5H853.6a.5.5,0,0,1-.5-.5v-2.7a.5.5,0,0,1,.5-.5h28A.5.5,0,0,1,882.1,214.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M920.2,247.3H900.8c-.2,0-.4.1-.4.3l-3.7,9.8c0,.2-.2.3-.4.3h-3.7a.4.4,0,0,1-.4-.6l15.7-42.6a.5.5,0,0,1,.5-.3h4.3c.2,0,.4.1.4.3l15.7,42.6a.4.4,0,0,1-.4.6h-3.7c-.2,0-.4-.1-.4-.3l-3.6-9.8A.5.5,0,0,0,920.2,247.3ZM919,243l-8-22c-.2-.4-.8-.4-.9,0L902,243a.5.5,0,0,0,.5.6h16A.5.5,0,0,0,919,243Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.7,36,282.2,8.7A28.3,28.3,0,0,0,261.7,0H205.3A20.3,20.3,0,0,0,185,20.3V67a34.3,34.3,0,0,0,8.2,22.3l46.4,54.9-76.3,76.4L87,144.2l-1.3,1.5L68.5,166,67,167.8,149.2,250a19.6,19.6,0,0,0,13.9,5.9h.3a19.6,19.6,0,0,0,13.9-5.9l84-83.8,18.8-18.8,29.7-29.7A57.9,57.9,0,0,0,309.7,36ZM287.8,96l-26.4,26.4L216.6,69.3a4.5,4.5,0,0,1-.7-2.3V30.9h45l27,27a26.8,26.8,0,0,1-.1,38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.3,0H65A29.4,29.4,0,0,0,44.3,8.6L16.9,36.1a57.7,57.7,0,0,0,.1,81.7L45.1,146,29.2,164.7A56.5,56.5,0,0,0,32.4,241a56.5,56.5,0,0,0,40,16.8h47.9V226.9h-48a26.1,26.1,0,0,1-16.6-6.1,25.1,25.1,0,0,1-8.9-17.5,25.5,25.5,0,0,1,6-18.7L67,167.8l1.5-1.8,17.2-20.3,1.3-1.5,46.5-54.9h0A35.4,35.4,0,0,0,141.7,67V20.3A20.6,20.6,0,0,0,121.3,0ZM110.8,67a3.2,3.2,0,0,1-.9,2.3h0l-44.8,53L38.7,96a27.3,27.3,0,0,1,0-38.2L65.8,30.9h45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M290.8,244.3a56.5,56.5,0,0,1-36.6,13.5H206.4V226.9h47.9a25.7,25.7,0,0,0,18.1-7.4,25.7,25.7,0,0,0,4.2-31,27,27,0,0,0-2.7-3.9l-14.3-16.8L281.5,146l15.8,18.7a3.9,3.9,0,0,1,.8,1h.1l1.5,2A56.6,56.6,0,0,1,290.8,244.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "87 144.2 67 167.8 86.1 187 106.9 164.1 87 144.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "65.1 122.4 45.1 146 22.3 123.1 44.3 101.5 65.1 122.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M299.8,167.6h-.1l-23.1,20.8h0a27,27,0,0,0-2.7-3.9l-14.3-16.8L281.5,146l16.6,19.7h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "261.4 122.4 239.6 144.2 220.4 121.5 242.6 100 261.4 122.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M463.1,169.1l-10.9,17.6a1.7,1.7,0,0,1-1.3.7h0a1.4,1.4,0,0,1-1.2-.7L380.6,72.6a1.4,1.4,0,0,1,0-1.5,1.4,1.4,0,0,1,1.2-.7h21.1a5,5,0,0,1,4.4,2.5l55.9,92.2A3.8,3.8,0,0,1,463.1,169.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M523.2,72.6l-48.5,77.9a1,1,0,0,1-.9.5.7.7,0,0,1-.9-.5l-11-18.1a4.3,4.3,0,0,1,0-4.4l34.4-55.2a5.1,5.1,0,0,1,4.3-2.4h21.3a1.4,1.4,0,0,1,1.3.7A1.4,1.4,0,0,1,523.2,72.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M654.6,84a55.6,55.6,0,0,0-19.1-10.2,83.7,83.7,0,0,0-24.2-3.4H547.6a1.3,1.3,0,0,0-1.3,1.3V183.5a1.3,1.3,0,0,0,1.3,1.3h63.7c17.5,0,32.3-4.5,43-13,8.7-7,19-20.2,19-43.8S663.1,91,654.6,84Zm-14.5,70a33.7,33.7,0,0,1-12.3,6,59.5,59.5,0,0,1-16.5,2.1H570.2a1.2,1.2,0,0,1-1.2-1.3V94.4a1.2,1.2,0,0,1,1.2-1.2h41.1c26,0,39.2,11.8,39.2,34.9C650.5,139.9,647.1,148.4,640.1,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M786.2,71.7V91.8a1.3,1.3,0,0,1-1.3,1.3H699a1.3,1.3,0,0,1-1.3-1.3V71.7a1.3,1.3,0,0,1,1.3-1.3h85.9A1.3,1.3,0,0,1,786.2,71.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M786.2,117.8v20.1a1.3,1.3,0,0,1-1.3,1.3H699a1.3,1.3,0,0,1-1.3-1.3V117.8a1.3,1.3,0,0,1,1.3-1.3h85.9A1.3,1.3,0,0,1,786.2,117.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M786.2,163.9V184a1.3,1.3,0,0,1-1.3,1.3H699a1.3,1.3,0,0,1-1.3-1.3V163.9a1.3,1.3,0,0,1,1.3-1.3h85.9A1.3,1.3,0,0,1,786.2,163.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M928.7,184.5a1.3,1.3,0,0,1-1.3.8H903.7a5.3,5.3,0,0,1-4-1.9l-30.2-37.7-30.3,37.7a5.1,5.1,0,0,1-4,1.9H811.6a1.6,1.6,0,0,1-1.4-.8,1.8,1.8,0,0,1,.2-1.6l44.5-55.3L810.8,72.8a1.5,1.5,0,0,1,1.1-2.4h23.7a5.1,5.1,0,0,1,4,1.9l29.9,37.2,29.8-37.2a5.3,5.3,0,0,1,4-1.9H927a1.3,1.3,0,0,1,1.3.8,1.4,1.4,0,0,1-.2,1.6L884,127.6l44.5,55.3A1.5,1.5,0,0,1,928.7,184.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualBetaWhiteLogo);
export default __webpack_public_path__ + "static/media/virtual-beta-white-logo.f17e25d9b6e4b1796d9d72612cfa52d8.svg";
export { ForwardRef as ReactComponent };